(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["phoenix-progress-orbit-metrics"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SECTION_SELECTOR = '[data-progress-orbit]';
    const GSAP_SRC = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js';

    const toNumber = (value, fallback) => {
      const parsed = Number.parseFloat(value);
      if (Number.isNaN(parsed)) {
        return fallback;
      }

      return parsed;
    };

    const ensureGsap = () => {
      if (window.gsap) {
        return Promise.resolve(window.gsap);
      }

      if (window.__progressOrbitGsapPromise) {
        return window.__progressOrbitGsapPromise;
      }

      window.__progressOrbitGsapPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = GSAP_SRC;
        script.async = true;
        script.onload = () => resolve(window.gsap);
        script.onerror = reject;
        document.head.appendChild(script);
      });

      return window.__progressOrbitGsapPromise;
    };

    const setupSection = (section, gsapInstance) => {
      if (section.dataset.progressOrbitReady === 'true') {
        return;
      }

      const cards = Array.from(section.querySelectorAll('[data-orbit-card]'));
      if (!cards.length) {
        section.dataset.progressOrbitReady = 'true';
        return;
      }

      const grid = section.querySelector('[data-progress-grid]');
      const animationDuration = toNumber(section.dataset.animationDuration, 1.4);
      const animationStagger = toNumber(section.dataset.animationStagger, 0.12);
      const animateOnScroll = section.dataset.animateOnScroll === 'true';
      const ringStyle = section.dataset.ringAnimationStyle || 'sweep';
      const decimals = Math.max(0, Math.min(2, Math.round(toNumber(section.dataset.numberDecimals, 0))));
      let hasRevealed = false;

      const formatNumber = (value, prefix, suffix) => {
        const formatted = decimals > 0 ? value.toFixed(decimals) : Math.round(value).toString();
        return `${prefix}${formatted}${suffix}`;
      };

      const prepareCard = (card) => {
        const circle = card.querySelector('[data-orbit-progress-circle]');
        const number = card.querySelector('[data-orbit-number]');
        const value = Math.max(0, Math.min(100, toNumber(card.dataset.value, 0)));
        const prefix = card.dataset.prefix || '';
        const suffix = card.dataset.suffix || '';

        if (!circle || !number) {
          return null;
        }

        const radius = circle.r.baseVal.value;
        const circumference = 2 * Math.PI * radius;

        circle.style.strokeDasharray = `${circumference}`;
        const initialOffset = circumference * (1 - value / 100);
        circle.style.strokeDashoffset = `${initialOffset}`;
        number.textContent = formatNumber(value, prefix, suffix);

        return {
          card,
          circle,
          number,
          value,
          prefix,
          suffix,
          circumference,
        };
      };

      const cardModels = cards.map(prepareCard).filter(Boolean);

      const updateRing = (model, progressValue) => {
        const clamped = Math.max(0, Math.min(100, progressValue));
        const offset = model.circumference * (1 - clamped / 100);
        model.circle.style.strokeDashoffset = `${offset}`;
        model.number.textContent = formatNumber(clamped, model.prefix, model.suffix);
      };

      const animateModel = (model, delay = 0, fromZero = false) => {
        if (!gsapInstance) {
          updateRing(model, model.value);
          return;
        }

        gsapInstance.killTweensOf(model.circle);

        const valueProxy = { value: 0 };
        let ease = 'power3.out';
        let targetValue = model.value;

        if (ringStyle === 'elastic') {
          ease = 'elastic.out(1, 0.45)';
        }

        if (ringStyle === 'bounce') {
          ease = 'back.out(1.5)';
          targetValue = Math.min(100, model.value + 6);
        }

        gsapInstance.to(valueProxy, {
          value: targetValue,
          delay,
          duration: animationDuration,
          ease,
          onStart: () => {
            if (fromZero) {
              updateRing(model, 0);
            }
          },
          onUpdate: () => updateRing(model, valueProxy.value),
          onComplete: () => {
            if (ringStyle === 'bounce') {
              gsapInstance.to(valueProxy, {
                value: model.value,
                duration: animationDuration * 0.36,
                ease: 'power2.out',
                onUpdate: () => updateRing(model, valueProxy.value),
              });
            }
          },
        });

        if (ringStyle === 'pulse') {
          gsapInstance.fromTo(
            model.card,
            { scale: 0.94 },
            {
              scale: 1,
              duration: animationDuration * 0.55,
              delay,
              ease: 'power2.out',
              immediateRender: false,
              onComplete: () => {
                gsapInstance.to(model.card, {
                  scale: 1.02,
                  duration: animationDuration * 0.26,
                  yoyo: true,
                  repeat: 1,
                  ease: 'sine.inOut',
                });
              },
            },
          );
        }

        if (ringStyle === 'burst') {
          gsapInstance.fromTo(
            model.card,
            { y: 14, opacity: 0 },
            { y: 0, opacity: 1, duration: animationDuration * 0.7, delay, ease: 'power3.out', immediateRender: false },
          );
          gsapInstance.fromTo(
            model.circle,
            { scale: 0.86, transformOrigin: '50% 50%' },
            { scale: 1, duration: animationDuration * 0.8, delay, ease: 'back.out(1.55)' },
          );
        }
      };

      const revealAll = () => {
        if (hasRevealed) {
          return;
        }
        hasRevealed = true;

        if (!gsapInstance) {
          cardModels.forEach((model) => updateRing(model, model.value));
          return;
        }

        gsapInstance.fromTo(
          grid,
          { opacity: 0, y: 22 },
          { opacity: 1, y: 0, duration: animationDuration * 0.6, ease: 'power2.out' },
        );

        cards.forEach((card, index) => {
          gsapInstance.fromTo(
            card,
            { opacity: 0, y: 16 },
            {
              opacity: 1,
              y: 0,
              duration: animationDuration * 0.6,
              delay: index * animationStagger,
              ease: 'power2.out',
              immediateRender: false,
            },
          );
        });

        cardModels.forEach((model, index) => animateModel(model, index * animationStagger, true));
      };

      const replayCard = (blockId) => {
        const model = cardModels.find((entry) => entry.card.dataset.blockId === blockId);
        if (!model) {
          return;
        }

        updateRing(model, 0);
        animateModel(model, 0, true);
      };

      section.__progressOrbitReplayCard = replayCard;

      if (animateOnScroll) {
        if (typeof IntersectionObserver === 'function') {
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  revealAll();
                  observer.disconnect();
                }
              });
            },
            { threshold: 0.05 },
          );

          observer.observe(section);

          const rect = section.getBoundingClientRect();
          const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
          const mostlyVisible = rect.top < viewportHeight * 0.92 && rect.bottom > viewportHeight * 0.08;
          if (mostlyVisible) {
            revealAll();
            observer.disconnect();
          }
        } else {
          revealAll();
        }
      } else {
        revealAll();
      }

      section.dataset.progressOrbitReady = 'true';
    };

    const initAll = () => {
      ensureGsap()
        .catch(() => null)
        .then((gsapInstance) => {
          document.querySelectorAll(SECTION_SELECTOR).forEach((section) => setupSection(section, gsapInstance));
        });
    };

    document.addEventListener('shopify:block:select', (event) => {
      const block = document.querySelector(`[data-block-id="${event.detail.blockId}"]`);
      if (!block) {
        return;
      }

      const section = block.closest(SECTION_SELECTOR);
      if (!section) {
        return;
      }

      if (typeof section.__progressOrbitReplayCard === 'function') {
        section.__progressOrbitReplayCard(event.detail.blockId);
      }
    });

    document.addEventListener('shopify:section:load', (event) => {
      const host = document.getElementById(`shopify-section-${event.detail.sectionId}`);
      if (!host) {
        return;
      }

      ensureGsap()
        .catch(() => null)
        .then((gsapInstance) => {
          host.querySelectorAll(SECTION_SELECTOR).forEach((section) => setupSection(section, gsapInstance));
        });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
